import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack } from '@mui/joy';
import ApplicantThumbnail from '../../components/ApplicantThumbnail';
import { getApplicants } from '../../../../apiconfig/api';
import { useEmployer } from '../../../../context/EmployerContext';

interface Applicant {
  id: string;
  name: string;
  position: string;
  videoUuid: string;
  user?: {
    fullName: string;
  };
}

interface SelectedCandidatesAvatarsProps {
  applicantIds: string[];
}

const SelectedCandidatesAvatars: React.FC<SelectedCandidatesAvatarsProps> = ({ applicantIds }) => {
  const [applicants, setApplicants] = useState<Applicant[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchApplicants = async () => {
      if (applicantIds.length === 0) {
        setApplicants([]);
        return;
      }

      setLoading(true);
      try {
        const response = await getApplicants(applicantIds);
        if (response.success && response.data) {
          const applicantsData = Array.isArray(response.data.applicants) ? response.data.applicants : [];
          setApplicants(applicantsData);
        } else {
          console.error('SelectedCandidatesAvatars invalid response structure:', response);
          setApplicants([]);
        }
      } catch (error) {
        console.error('Error fetching applicants in SelectedCandidatesAvatars:', error);
        setApplicants([]);
      } finally {
        setLoading(false);
      }
    };

    fetchApplicants();
  }, [applicantIds]);

  if (loading) {
    return (
      <Box mb={2}>
        <Typography level="body-sm" mb={1}>Selected People</Typography>
        <Typography level="body-sm" color="neutral">Loading...</Typography>
      </Box>
    );
  }
  
  return (
    <Box mb={2}>
      <Typography level="body-sm" mb={1}>Selected People</Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {applicants.length > 0 ? (
          applicants.map(applicant => (
            <Box key={applicant.id} sx={{ width: 40, height: 40, borderRadius: 2, overflow: 'hidden', mr: 2, flexShrink: 0 }}>
              <ApplicantThumbnail applicant={applicant} />
            </Box>
          ))
        ) : (
          <Typography color="danger">No people selected.</Typography>
        )}
      </Stack>
    </Box>
  );
};

export default SelectedCandidatesAvatars; 